import { css, cx } from "@linaria/core"
import { styled } from "@linaria/react"

import { Horizontal } from "@/components/Flex.ts"
import { Icon16, Icon20, SpinnerMedium } from "@/icons/Icons.ts"

export const Spinner = (props: {
  text?: string
  size?: 16 | 20 | 24
}) => {
  if (props.text) {
    return (
      <Container>
        <Icon size={props.size} />
        <span>{props.text}</span>
      </Container>
    )
  }

  return <Icon size={props.size} />
}

const Icon = (props: {
  size?: 16 | 20 | 24
}) => {
  switch (props.size) {
    case 16:
      return <SpinnerMedium className={cx(Rotate, Icon16)} />
    case 20:
      return <SpinnerMedium className={cx(Rotate, Icon20)} />
    case 24:
      return <SpinnerMedium className={Rotate} />
    case undefined:
      return <SpinnerMedium className={Rotate} />
  }
}

const Container = styled(Horizontal)`
  overflow: hidden;

  align-items: center;
  gap: 4px;
`

export const Rotate = css`
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  animation: rotate 1s linear infinite;
`
